const ORG_PAGES = [
  {
    key: 'team-overview',
    route: '/overview',
    text: 'Team Overview',
  },
  {
    key: 'player-outlook',
    route: '/player-outlook',
    text: 'Player Outlook',
  },
  {
    key: 'ml-team',
    route: '/ml-team',
    text: 'ML Team',
  },
  {
    key: 'financial',
    route: '/financial',
    text: 'Financial',
  },
  {
    key: 'future-proj',
    route: '/future-projections',
    text: 'Future Projections',
  },
  {
    key: 'team-outlook',
    route: '/team-outlook',
    text: 'Team Outlook',
  },
  {
    key: 'pro-looks',
    route: '/pro-looks',
    text: 'Pro Looks',
  },
  {
    key: 'perf-hitters',
    route: '/performance-hitters',
    text: 'Performance Hitters',
  },
  {
    key: 'perf-pitchers',
    route: '/performance-pitchers',
    text: 'Performance Pitchers',
  },
  {
    key: 'def-by-pos',
    route: '/defense-by-pos',
    text: 'Defense By Pos',
  },
  {
    key: 'proj-and-value',
    route: '/projections-and-value',
    text: 'Projections & Value',
  },
  {
    key: 'industry',
    route: '/industry',
    text: 'Industry',
  },
  {
    key: 'long-grid',
    route: '/longitudinal-grid',
    text: 'Longitudinal Grid',
  },
  {
    key: 'contracts',
    route: '/contracts',
    text: 'Contracts',
  },
  {
    key: 'scout-fx-trends',
    route: '/scout-fx-trends',
    text: 'ScoutFX Trends',
  },
  {
    key: 'affiliate-perf',
    route: '/affiliate-performance',
    text: 'Affiliate Performance',
  },
  {
    key: 'conversations',
    route: '/conversations',
    text: 'Conversations',
  },
];

export { ORG_PAGES };
